"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DialogContentText_1 = require("./DialogContentText");
const { root } = DialogContentText_1.dialogContentTextClasses;
const MuiDialogContentTextOverrides = {
    MuiDialogContentText: {
        styleOverrides: {
            root: ({ theme }) => ({
                [`&.${root}`]: {
                    color: theme.palette.gray[900],
                    fontWeight: theme.typography.fontWeightRegular,
                    fontSize: '16px',
                }
            }),
        },
    },
};
exports.default = MuiDialogContentTextOverrides;
//# sourceMappingURL=MuiDialogContentTextOverrides.js.map